define('../src/sublayouts/m1-header/m1-header',['jquery'], function($) {

    'use strict';

    var M1_HEADING = function($component) {

        this.$component = $component;

        return this;
    };

    /**
     * Initialize component
     */

    M1_HEADING.prototype.init = function() {
        var _this = this;

        this.headerBarTop = this.$component.offset().top;
        this.fixedHeader = false;

        this.language();
        this.watchHeader();

        //$(window).scroll( $.proxy( this.watchHeader, this ) );
        $(window).off('scroll.m1').on('scroll.m1', function() {
            _this.watchHeader();
        });
    };

    M1_HEADING.prototype.language = function() {
        var _this = this;

        if (this.$component.find('.form-field__switch-checkbox').prop('checked')) {
            _this.$component.find('.m1-header--lang_label--ar').addClass('m1-header--lang_label--active');
            _this.$component.find('.m1-header--lang_label--en').removeClass('m1-header--lang_label--active');
        } else {
            _this.$component.find('.m1-header--lang_label--en').addClass('m1-header--lang_label--active');
            _this.$component.find('.m1-header--lang_label--ar').removeClass('m1-header--lang_label--active');
        }

        this.$component.find('.form-field__switch-checkbox').off('click.lang').on('click.lang', function() {
            _this.$component.find('.m1-header--lang_label span').each(function() {
                $(this).toggleClass('m1-header--lang_label--active');
            });
            setTimeout(function() {
                window.location.href = _this.$component.find('.m1-header--lang_a').attr('href');
            }, 300);
        });
    };

    M1_HEADING.prototype.watchHeader = function() {
        var _this = this,
            scrollTop = $(window).scrollTop(),
            position = 0;

        if ($(window).scrollTop() > 50) {
            if (!this.fixedHeader) {
                _this.$component.addClass('fixed');
                this.fixedHeader = true;
            }
        } else if (this.fixedHeader) {
            _this.$component.removeClass('fixed');
            this.fixedHeader = false;

        };
    };

    return M1_HEADING;
});

